import {useState} from 'react'

export const useViewState = ({viewStates, initialView}) => {
  const [viewState, setViewState] = useState(initialView)

  const dispatchViewState = ({action}) => {
    let nextAction = viewStates[viewState][action]

    // Check if the nextAction is a Promise
    let nextView = nextAction()
    let isPromise = false

    if (nextView && typeof nextView.then === 'function') {
      isPromise = true
    }

    if (isPromise) {
      nextView.then(nextState => {
        if (nextState) {
          setViewState(nextState)
        }
      })
    } else {
      if (nextView) {
        setViewState(nextView)
      }
    }
  }

  // TODO: Add error for submits?
  return {
    viewState,
    dispatchViewState
  }
}
